import { TExperimentalInfoField } from 'domains/campaign/types';

export const getCurrentVariableField = (
  fieldsConfig: TExperimentalInfoField[] | null | undefined,
  fieldName: string,
): TExperimentalInfoField | undefined =>
  fieldsConfig?.find((item) => item.field === fieldName);
